import { makeStyles } from "@mui/styles"

export default makeStyles(() => ({
    root: {
        borderRadius: 0,
        backgroundColor: "rgb(255,179,66)"
    }
}))
